import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Model, Watch } from "vue-property-decorator";

@Component
export default class Base extends Vue {
  @Prop()
  protected model!: IndexObject;
  @Prop()
  protected prop!: IProp;
  @Prop()
  protected readonly!: boolean;

  created() {
    try {
      let value = eval("this.model." + this.prop.value);
      if (!value) {
        value = this.getInitalValue();
        this.$set(this.model, this.prop.value, value);
      }
    } catch (error) {
      this.$set(this.model, this.prop.value, undefined);
    }
  }

  protected getInitalValue() {
    let type = this.prop.type;
    switch (type) {
      case "number":
        return 0;
      case "boolean":
        return false;
      case "date":
        return new Date().toISOString().substr(0, 10);
      default:
        return "";
    }
  }
}
